import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingTiffToJpgConfig } from '@/data/landingConfig/landingTiffToJpgConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_TiffToJpg } from './schemaObject';

interface Props {}
const TiffToJpgConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_TiffToJpg} />
			<LandingTemplate
				data={landingTiffToJpgConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default TiffToJpgConverter;
